import CatalogMenuFilter from "@/views/CatalogMenuFilter";
import Connect from "@/views/Connect";
import Subscribers from "@/views/Subscribers";
import { createRouter, createWebHistory } from "vue-router";
import AdminBox from "../components/AdminBox";
import CallBack from "../views/CallBack";
import Forgot from "../views/Forgot";
// import LandingPage from '../views/LandingPage';
import MultisendItem from "../views/MultisendItem";
import Multisend from "../views/Multisend";
import MultisendBusked from "../views/MultisendBusked";
import Options from "../views/Options";
import Chat from "../views/Chat";
import Dashboard from "../views/Dashboard.vue";
import Catalog from "../views/Catalog.vue";
// import EditItem from '../views/EditItem.vue'

import Login from "../views/Login.vue";
import Orders from "../views/Orders";
import Sender from "../views/Sender";
import Settings from "../views/Settings";
import SettingsBasic from "../views/SettingsBasic";
import SettingsMessage from "../views/SettingsMessage";
import SettingsOptions from "../views/SettingsOptions";
import SettingsPages from "../views/SettingsPages";
import SettingsPassword from "../views/SettingsPassword";
import Translate from "../views/Translate";
import Users from "../views/Users";
import Calendar from "../views/Calendar";
import SettingsApi from "@/views/SettingsApi";
import AdminSupport from "@/views/AdminSupport";
import AppInstaram from "@/views/AppInstaram";
import SettingsPayments from "@/views/SettingsPayments";
import SettingsDeliveries from "@/views/SettingsDeliveries";
import Categories from "@/views/Categories";
import Tags from "@/views/Tags";
import SettingsDeliveriesAdd from "@/views/SettingsDeliveriesAdd";
import SettingsPaymentsAdd from "@/views/SettingsPaymentsAdd";
import Reviews from "@/views/Reviews";
import Leads from "@/views/Leads";
import Landings from "@/views/Landings";
import ManagerBox from "@/views/ManagerBox";

const routes = [
  {
    path: "/",
    name: "Box",
    component: AdminBox,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
      },
      {
        path: "/options/:option_id?",
        name: "Options",
        component: Options,
        props: (route) => ({
          option_id: route.params.option_id ? route.params.option_id : "tags",
        }),
      },
      {
        path: "/categories",
        name: "Categories",
        component: Categories,
      },
      {
        path: "/menu",
        name: "CatalogMenuFilter",
        component: CatalogMenuFilter,
      },
      {
        path: "/tags",
        name: "Tags",
        component: Tags,
      },
      {
        path: "/module",
        name: "Connect",
        component: Connect,
      },

      {
        path: "/catalog/:page?",
        name: "Catalog",
        component: Catalog,
        props: true,
      },
      // {
      //     path: '/item/:id',
      //     name: 'EditItem',
      //     component: EditItem,
      //     props: true
      // },
      {
        path: "/orders/:page?",
        name: "Orders",
        component: Orders,
        props: true,
      },
      {
        path: "/leads/:page?",
        name: "Leads",
        component: Leads,
        props: true,
      },
      {
        path: "/landings",
        name: "Landings",
        component: Landings,
        props: true,
      },
      {
        path: "/users/:page?",
        name: "Users",
        component: Users,
        props: true,
      },
      {
        path: "/subscribers/:page?",
        name: "Subscribers",
        component: Subscribers,
        props: true,
      },
      {
        path: "/callback/:page?",
        name: "CallBack",
        component: CallBack,
        props: true,
      },
      {
        path: "/sender",
        name: "Sender",
        component: Sender,
      },
      {
        path: "/chat",
        name: "Chat",
        component: Chat,
      },
      {
        path: "/settings",
        name: "Settings",
        component: Settings,
        children: [
          {
            path: "info",
            name: "SettingsBasic",
            component: SettingsBasic,
          },
          {
            path: "/payments",
            name: "SettingsPayments",
            component: SettingsPayments,
          },
          {
            path: "/payments/add",
            name: "AddPayments",
            component: SettingsPaymentsAdd,
          },
          {
            path: "/delivery",
            name: "SettingsDeliveries",
            component: SettingsDeliveries,
          },
          {
            path: "/delivery/add",
            name: "AddDelivery",
            component: SettingsDeliveriesAdd,
          },
          {
            path: "options",
            name: "SettingsOptions",
            component: SettingsOptions,
          },
          {
            path: "pages",
            name: "SettingsPage",
            component: SettingsPages,
          },
          {
            path: "messages",
            name: "SettingsMessages",
            component: SettingsMessage,
          },
          {
            path: "api",
            name: "SettingsApi",
            component: SettingsApi,
          },
          {
            path: "password",
            name: "SettingsPassword",
            component: SettingsPassword,
          },
        ],
      },
      {
        path: "/app",
        name: "Apps",
        component: Settings,
        children: [
          {
            path: "instagram",
            name: "AppInstagram",
            component: AppInstaram,
          },
        ],
      },

      {
        path: "/translate",
        name: "Translate",
        component: Translate,
      },
      {
        path: "/reviews/:status?/:page?",
        name: "Reviews",
        component: Reviews,
        props: true,
      },
      {
        path: "/support",
        name: "AdminSupport",
        component: AdminSupport,
      },
      {
        path: "/calendar",
        name: "Calendar",
        component: Calendar,
      },
      {
        path: "/multisend/:page?",
        name: "Multisend",
        component: Multisend,
        props: true,
      },
      {
        path: "/multisend_busked/:page?",
        name: "MultisendBusked",
        component: MultisendBusked,
        props: true,
      },

      {
        path: "/post/:id?",
        name: "PostEdit",
        component: MultisendItem,
        props: true,
      },
      {
        path: "/copypost/:copy?",
        name: "CopyPostEdit",
        component: MultisendItem,
        props: true,
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/forgot",
    name: "forgot",
    component: Forgot,
  },
  {
    path: "/manager",
    name: "manager",
    component: ManagerBox,
    props: true,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
